import { Spin } from "antd";
import { ITextInputErrorWarning } from "../../../store/@types/misc";
import React from "react";

type ISelectDate = {
  label: string;
  name: string;
  value: string;
  placeholder: string;
  required?: boolean;
  status?: ITextInputErrorWarning;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading?: boolean;
  icon?: React.ReactNode;
};

const SelectDate: React.FC<ISelectDate> = ({
  label,
  name,
  value,
  placeholder,
  required,
  status,
  onChange,
  icon,
  loading,
}) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const borderColor = status ? "border-[red]" : "border-[#e5e7eb]";
  return (
    <div className="w-full">
      <label className="text-md font-medium">{label}</label>
      <div
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={`flex w-full border items-center rounded-lg mt-1 text-gray-900 px-3 py-2 bg-[white] ${
          isFocused ? "border-primary-500" : borderColor
        } focus-within:ring focus-within:ring-primary-100/30`}
      >
        {icon && <div className="mr-1 border-r pr-2">{icon}</div>}
        <input
          type="date"
          value={value}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className="w-full !outline-none px-0 py-0 placeholder:text-gray-400 border-none focus:border-transparent bg-[white] focus:ring-0"
        />
        {loading && <Spin size="small" />}
      </div>
    </div>
  );
};

export default SelectDate;
